import React, { useEffect } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import AutoScroll from 'embla-carousel-auto-scroll';
import { ClockIcon, PrinterIcon, SmartphoneIcon } from 'lucide-react';
import { offerAnchor, sampleMaps } from '../data/content';
import { CtaButton } from './CtaButton';
const perks = [{
  icon: ClockIcon,
  label: 'Consultá en minutos'
}, {
  icon: SmartphoneIcon,
  label: 'Usalo desde cualquier dispositivo'
}, {
  icon: PrinterIcon,
  label: 'Imprimí tus mapas favoritos'
}];
export function MapGallery() {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    align: 'start',
    dragFree: true,
    containScroll: false,
    watchDrag: false,
    watchFocus: false
  }, [AutoScroll({
    speed: 0.9,
    startDelay: 400,
    stopOnInteraction: false,
    stopOnMouseEnter: false,
    stopOnFocusIn: false
  })]);
  useEffect(() => {
    if (!emblaApi) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!reduce.matches) return;
    const autoScroll = emblaApi.plugins().autoScroll;
    autoScroll?.stop();
  }, [emblaApi]);
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-81" data-mp="xb886ksxcw3e">
      <header className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-82" data-mp="xaq2kxkdh5it">
        <p className="font-sans text-xs font-bold uppercase tracking-[0.18em] text-forest-600" data-id="element-83" data-mp="1299q32em6pda">
          Mirá por dentro
        </p>
        <h2 className="mt-4 font-display text-[2rem] font-extrabold leading-[1.12] tracking-tight text-ink md:text-5xl" data-id="element-84" data-mp="nk3ppb41it3t">
          No son frases sueltas. Son mapas visuales para usar cuando realmente los necesitás.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-lg text-gray-500 md:text-xl" data-id="element-85" data-mp="imbrjzcsyar6">
          Cada mapa convierte la sabiduría de Proverbios y Eclesiastés en algo que podés entender,
          reflexionar y aplicar en minutos.
        </p>
      </header>

      <div className="mt-12 overflow-hidden md:mt-16" ref={emblaRef} aria-label="Muestra de mapas visuales del producto" data-id="element-86" data-mp="9kcaj71sf6o8">
        <ul className="flex select-none items-start pl-5 md:pl-8" data-id="element-87" data-mp="26kctq6md9iq2">
          {sampleMaps.map(map => <li key={map.src} className="min-w-0 shrink-0 grow-0 basis-[80%] pr-5 sm:basis-1/2 lg:basis-1/3 xl:basis-[28%]" data-id="element-88" data-mp="22hznzi7mdkta">
              <img src={map.src} alt={map.alt} className="w-full rounded-xl bg-white shadow-soft ring-1 ring-gray-200" loading="lazy" draggable={false} data-id="element-89" data-mp="1xhbqcdovy5q3" />
            </li>)}
        </ul>
      </div>

      <div className="mx-auto mt-12 w-full max-w-narrow px-5 text-center md:px-8" data-id="element-90" data-mp="2lattlljcs0ku">
        <p className="text-lg text-gray-500" data-id="element-91" data-mp="2g9o0hmls6bas">
          Esto es solo una muestra. Recibís más de{' '}
          <span className="font-semibold text-ink" data-id="element-92" data-mp="19v53ilasylft">130 mapas visuales</span> organizados en 4 tomos.
        </p>

        <div className="mt-9" data-id="element-93" data-mp="14x3oqcket8a5">
          <CtaButton size="lg" href={offerAnchor} data-id="element-94" data-mp="urc4pi9kohep">
            Accedé a los 130 mapas ahora
          </CtaButton>
        </div>

        <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-semibold text-gray-500" data-id="element-95" data-mp="zqot47g3dwje">
          {perks.map(perk => <li key={perk.label} className="inline-flex items-center gap-2" data-id="element-96" data-mp="19fgh64i17wp1">
              <perk.icon className="h-4 w-4 shrink-0 text-forest-600" aria-hidden="true" data-id="element-97" data-mp="19hjgxg8zl46y" />
              {perk.label}
            </li>)}
        </ul>
      </div>
    </section>;
}